import StaffPerformanceHTMLPreviewBaseSection from './StaffPerformanceHTMLPreviewBaseSection'

export default function StaffPerformanceHTMLPreviewHeaderSection() {}

StaffPerformanceHTMLPreviewHeaderSection.prototype = new StaffPerformanceHTMLPreviewBaseSection();

StaffPerformanceHTMLPreviewHeaderSection.prototype.init = function( firstGroupingLevel, secondGroupingLevel, thirdGroupingLevel, columnsStrategy )
{
    StaffPerformanceHTMLPreviewBaseSection.prototype.init.call(this, columnsStrategy);

    this.firstGroupingLevel = firstGroupingLevel;
    this.secondGroupingLevel = secondGroupingLevel;
    this.thirdGroupingLevel = thirdGroupingLevel;
    return this;
};

StaffPerformanceHTMLPreviewHeaderSection.prototype.addRows = function( tBody )
{
    this.addRow( tBody, this.createFirstHeaderRow() );
    this.addRow( tBody, this.createSecondHeaderRow() );
};

StaffPerformanceHTMLPreviewHeaderSection.prototype.createFirstHeaderRow = function ()
{
    let row = this.createRow("headerRow firstHeaderRow")
    this.addCell(
            row,
            ReportPreviewUtils.makeGroupingHeader(
                    [   this.firstGroupingLevel,
                        this.secondGroupingLevel,
                        this.thirdGroupingLevel
                    ]
            ), "groupingLevelsTitle firstChild", 1, 2 );
    this.columnsStrategy.addFirstHeaderRowCells( row );
    return row;
};

StaffPerformanceHTMLPreviewHeaderSection.prototype.createSecondHeaderRow = function ()
{
    let row = this.createRow("headerRow secondHeaderRow")
    this.columnsStrategy.addSecondHeaderRowCells( row );
    return row;
};


// WEBPACK FOOTER //
// ./web/js/reports/preview/html/staffperformance/StaffPerformanceHTMLPreviewHeaderSection.js